import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { NzButtonModule } from "ng-zorro-antd/button";
import { NzCardModule } from "ng-zorro-antd/card";
import { NzCheckboxModule } from "ng-zorro-antd/checkbox";
import { NzFormModule } from "ng-zorro-antd/form";
import { NzIconModule } from "ng-zorro-antd/icon";
import { NzInputModule } from "ng-zorro-antd/input";
import { SharedModule } from "../../shared/shared.module";
import { LoginRoutingModule } from "./login-routing.module";
import { LoginComponent } from "./login.component";

import { NzModalModule } from "ng-zorro-antd/modal";
import { NzPopconfirmModule } from "ng-zorro-antd/popconfirm";
import { RouterModule } from "@angular/router";

@NgModule({
  declarations: [LoginComponent],
  imports: [
    CommonModule,
    LoginRoutingModule,
    NzIconModule,
    NzFormModule,
    NzCheckboxModule,
    NzButtonModule,
    NzCardModule,
    SharedModule,
    NzInputModule,
    NzModalModule,
    NzPopconfirmModule,
    RouterModule
  ],
  providers: [],
})
export class LoginModule {}
